import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-417036a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  t: "1669711519501",
  style: {marginTop: '7px'},
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "6936",
  width: "16",
  height: "16",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M943.254 375.558l-0.12-0.1c-17.357-14.294-42.775-11.232-56.859 6.295C798.229 491.322 663.174 561.584 512 561.584s-286.229-70.262-374.274-179.831c-14.084-17.527-39.502-20.589-56.859-6.295l-0.12 0.1c-16.76 13.801-19.687 38.642-6.122 55.594 43.269 54.077 96.432 99.831 156.62 134.821L170.943 689.61c-9.685 19.855-1.439 43.803 18.416 53.486h0.001c19.855 9.685 43.802 1.439 53.486-18.416l60.279-123.591c52.793 21.266 109.532 34.73 168.875 38.927v137.568c0 22.091 17.908 40 40 40s40-17.909 40-40V640.016c59.343-4.196 116.082-17.661 168.875-38.927l60.279 123.591c9.685 19.855 33.631 28.101 53.486 18.417 19.856-9.685 28.102-33.632 18.417-53.487l-60.302-123.637c60.188-34.99 113.352-80.744 156.62-134.821 13.565-16.953 10.639-41.794-6.121-55.594z",
  fill: "#afb9cd",
  "p-id": "6937"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createBlock(_component_a_input, {
    placeholder: _ctx.placeholder,
    value: _ctx.modelValue,
    onInput: _ctx.iptChange,
    autocomplete: "new-password",
    type: _ctx.pwdtype,
    style: {backgroundColor: 'transparent !important'}
  }, {
    suffix: _withCtx(() => [
      _createElementVNode("span", null, [
        (_ctx.pwdtype === 'password')
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.handleChangePwdtype('text')), ["prevent"])),
              style: {color: '#afb9cd'}
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
            ], 32))
          : _createCommentVNode("", true),
        (_ctx.pwdtype === 'text')
          ? (_openBlock(), _createBlock(_component_EyeOutlined, {
              key: 1,
              onMousedown: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleChangePwdtype('password')), ["prevent"])),
              style: {color: '#afb9cd', fontSize: '16px'}
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["placeholder", "value", "onInput", "type"]))
}